import type { EmploymentDetails, PeriodStartSetting } from "./employmentApi";

const helsinkiDateFormatter = new Intl.DateTimeFormat("sv-SE", {
  timeZone: "Europe/Helsinki",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

export const employmentDateInHelsinki = (now = new Date()): string =>
  helsinkiDateFormatter.format(now);

export const periodStartBaseline = (
  details: EmploymentDetails,
): string | null =>
  details.periodStartBaseline === undefined
    ? details.periodStartDate
    : details.periodStartBaseline;

export const resolvePeriodStartDate = (
  baseline: string | null,
  settings: readonly PeriodStartSetting[],
  date: string,
): string | null => {
  const active = settings.reduce<PeriodStartSetting | undefined>(
    (latest, setting) =>
      setting.from <= date && (!latest || latest.from < setting.from)
        ? setting
        : latest,
    undefined,
  );
  return active?.periodStart ?? baseline;
};
